export default [
  {
    path: "/course-order",
    component: (resolve) => require(["@/vuepage/order-manage/course-order.vue"], resolve),
    meta: [
      {
        name: "订单管理",
      },
      {
        name: "课程订单",
        activeRoute: "/course-order",
      },
    ],
  },
  {
    path: "/course-order-detail",
    component: (resolve) => require(["@/vuepage/order-manage/course-detail.vue"], resolve),
    meta: [
      {
        name: "订单管理",
      },
      {
        name: "订单详情",
        activeRoute: "/course-order-detail",
      },
    ],
  },
  {
    path: "/product-order",
    component: (resolve) => require(["@/vuepage/order-manage/product-order.vue"], resolve),
    meta: [
      {
        name: "订单管理",
      },
      {
        name: "商品订单",
        activeRoute: "/product-order",
      },
    ],
  },
  {
    path: "/product-detail",
    component: (resolve) => require(["@/vuepage/order-manage/product-detail.vue"], resolve),
    meta: [
      {
        name: "订单管理",
      },
      {
        name: "商品订单详情",
        activeRoute: "/product-order",
      },
    ],
  },
  {
    path: "/order-train",
    component: (resolve) => require(["@/vuepage/order-manage/order-train.vue"], resolve),
    meta: [
      {
        name: "培训计划",
      },
      {
        name: "培训计划",
        activeRoute: "/product-order",
      },
    ],
  },
  {
    path: "/order-trainlog",
    component: (resolve) => require(["@/vuepage/order-manage/order-trainlog.vue"], resolve),
    meta: [
      {
        name: "培训记录",
      },
      {
        name: "培训记录",
        activeRoute: "/product-order",
      },
    ],
  },
];
